import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';
import { exitTimeout } from './Loader.scss';

class Loader extends Component {
    state = {
        exitting: false,
        hidden: false
    }

    static propTypes = {
        hide: PropTypes.bool.isRequired
    }

    static getDerivedStateFromProps({ hide }, { exitting, hidden }) {
        if (!hide) {
            return {
                hidden: false
            }
        }
        else if (hidden) {
            return null;
        }

        return {
            exitting: hide
        };
    }

    shouldComponentUpdate(nextProps, { exitting }) {
        if (!exitting) {
            return true;
        }

        setTimeout(() => this.setState({
            exitting: false,
            hidden: true
        }), parseInt(exitTimeout, 10));

        return true;
    }

    render() {
        const {
            exitting,
            hidden
        } = this.state;

        if (hidden || !process.browser) {
            return null;
        }

        return (
            <div className={`loader ${exitting ? 'fade-out' : ''}`}>
                <div className="spinner">
                    <div></div>{' '}
                    <div></div>{' '}
                    <div></div>{' '}
                    <div></div>{' '}
                    <div></div>
                </div>
            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/views/Home/base/Loader.js